import { useState } from 'react';
import { imagesFromClipboard } from '@/components/imageIntake/clipboardImages';

const isInsideTarget = (event: React.SyntheticEvent): boolean => event.currentTarget.contains(event.target as Node);

const carriesFiles = (event: React.DragEvent): boolean =>
  isInsideTarget(event) && [...event.dataTransfer.types].includes('Files');

const carriesText = (clipboardData: DataTransfer): boolean => [...clipboardData.types].includes('text/plain');

export const useImageDropAndPaste = (onImages: (files: File[]) => void) => {
  const [dragDepth, setDragDepth] = useState(0);

  const dropAndPasteHandlers = {
    onDragEnter: (event: React.DragEvent) => {
      if (!carriesFiles(event)) return;
      event.preventDefault();
      setDragDepth(depth => depth + 1);
    },
    onDragOver: (event: React.DragEvent) => {
      if (carriesFiles(event)) event.preventDefault();
    },
    onDragLeave: (event: React.DragEvent) => {
      if (carriesFiles(event)) setDragDepth(depth => Math.max(depth - 1, 0));
    },
    onDrop: (event: React.DragEvent) => {
      if (!carriesFiles(event)) return;
      event.preventDefault();
      setDragDepth(0);
      onImages([...event.dataTransfer.files]);
    },
    onPaste: (event: React.ClipboardEvent) => {
      const images = imagesFromClipboard(event.clipboardData);
      if (images.length === 0 || carriesText(event.clipboardData) || !isInsideTarget(event)) return;
      event.preventDefault();
      onImages(images);
    },
  };

  return { isDragActive: dragDepth > 0, dropAndPasteHandlers };
};
